import React from 'react';
import { useNavigate } from "react-router-dom";
import './Footer.css';

const Footer: React.FC = () => {
    const navigate = useNavigate();

    return (
        <footer className="app-footer">
            <button
                type="button"
                className="footer-privacy-link"
                onClick={() => navigate('/privacy-policy')}
            >
                개인정보처리방침
            </button>
        </footer>
    );
};

export default Footer;
